import { buildCategoryTree } from 'dashboard/helper/categoryTreeHelper';

// recursively sum a node's own article count with those of all its descendants
const withAggregateCounts = node => {
  const children = (node.children || []).map(withAggregateCounts);
  const ownCount = node.meta?.articles_count || 0;
  const totalArticlesCount = children.reduce(
    (sum, child) => sum + child.totalArticlesCount,
    ownCount
  );
  return { ...node, children, totalArticlesCount };
};

export const getters = {
  uiFlags: state => helpCenterId => {
    const uiFlags = state.categories.uiFlags.byId[helpCenterId];
    if (uiFlags) return uiFlags;
    return { isFetching: false, isUpdating: false, isDeleting: false };
  },
  isFetching: state => state.uiFlags.isFetching,
  isCreating: state => state.uiFlags.isCreating,
  categoryById:
    (...getterArguments) =>
    categoryId => {
      const [state] = getterArguments;
      const category = state.categories.byId[categoryId];
      if (!category) return undefined;
      return category;
    },
  allCategories: (...getterArguments) => {
    const [state, _getters] = getterArguments;
    const categories = state.categories.allIds.map(id => {
      return _getters.categoryById(id);
    });
    return categories;
  },
  categoriesByLocaleCode:
    (...getterArguments) =>
    localeCode => {
      const [state, _getters] = getterArguments;
      const categories = state.categories.allIds.map(id => {
        return _getters.categoryById(id);
      });
      return categories.filter(category => category.locale === localeCode);
    },
  // roots with nested `children` (+ a rolled-up totalArticlesCount) built from the flat store.
  // The store only ever holds the current locale (index clears before adding), so this is
  // naturally locale-scoped.
  categoryTree: (...getterArguments) => {
    const [, _getters] = getterArguments;
    return buildCategoryTree(_getters.allCategories).map(withAggregateCounts);
  },
  getMeta: state => {
    return state.meta;
  },
};
